import React from "react";
import { ECLThemeImage } from "../../../../eclComponents";
import { Handle, Position } from "@xyflow/react";

const ExplorerNode = ({ data }) => {
   return (
      <div
         className="nowheel"
         style={{
            display: "flex",
            flexDirection: "column",
            padding: "5px",
            border: "1px solid #777",
            borderRadius: "10px",
            height: "400px",
            maxHeight: "400px",
            overflow: "auto",
         }}
      >
         <Handle type="target" position={Position.Top} />
         <div
            style={{
               display: "flex",
               height: "50px",
               width: "100%",
               justifyContent: "space-between",
            }}
         >
            <ECLThemeImage fontAwesome="scroll" style={{ width: "25px" }} />
            <p style={{ width: "calc(100% - 25px)" }}>{data.label}</p>
         </div>
         {data.properties.map((p) => {
            return (
               <div
                  key={data.ULID + p.ULID}
                  style={{
                     display: "flex",
                     width: "100%",
                     alignItems: "center",
                  }}
               >
                  <ECLThemeImage
                     fontAwesome={p.link ? "paperclip" : "cube"}
                     style={{ width: "25px", height: "25px" }}
                  />
                  <p>{p.name}</p>
               </div>
            );
         })}

         <Handle type="source" position={Position.Bottom} />
      </div>
   );
};

export default ExplorerNode;
